import React from 'react';
var I18n = React.createContext({});
var Storage = React.createContext({});
var Remote = React.createContext({});
var Loading = React.createContext({});
export function withI18n(Child) {
  return function I18nChild(props) {
    return React.createElement(I18n.Consumer, null, function (_ref) {
      var i18n = _ref.i18n,
          locale = _ref.locale,
          setLocale = _ref.setLocale,
          installComponent = _ref.installComponent;
      return React.createElement(Child, Object.assign({}, props, {
        i18n: i18n,
        locale: locale,
        setLocale: setLocale,
        installComponent: installComponent
      }));
    });
  };
}
export function withThreeSkyeGlobal(Child) {
  return function ThreeSkyeGlobalChild(props) {
    return React.createElement(Remote.Consumer, null, function (remote) {
      return React.createElement(Storage.Consumer, null, function (storage) {
        return React.createElement(I18n.Consumer, null, function (_ref2) {
          var i18n = _ref2.i18n,
              locale = _ref2.locale;
          return React.createElement(Loading.Consumer, null, function (loading) {
            return React.createElement(Child, Object.assign({}, props, {
              i18n: i18n,
              locale: locale,
              storage: storage,
              remote: remote,
              loading: loading
            }));
          });
        });
      });
    });
  };
}
export function withStorage(Child) {
  return function StorageChild(props) {
    return React.createElement(Storage.Consumer, null, function (storage) {
      return React.createElement(Child, Object.assign({}, props, {
        storage: storage
      }));
    });
  };
}
export function withRemote(Child) {
  return function RemoteChild(props) {
    return React.createElement(Remote.Consumer, null, function (remote) {
      return React.createElement(Child, Object.assign({}, props, {
        remote: remote
      }));
    });
  };
}
export function withLoading(Child) {
  return function LoadingChild(props) {
    return React.createElement(Loading.Consumer, null, function (loading) {
      return React.createElement(Child, Object.assign({}, props, {
        loading: loading
      }));
    });
  };
}
var ThreeSkyeGlobal = {
  "i18n": I18n,
  "storage": Storage,
  "remote": Remote
};
export default ThreeSkyeGlobal;
export { I18n, Storage, Remote, Loading };